import { useEffect, useState } from "react"

import { ExecutionRun } from "@vertesia/common"
import { ListRestart } from "lucide-react"

import { Button } from "@ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@ui/dialog"
import { Input } from "@ui/input"
import { useUserSession } from "@session/UserSession"

const COMPARE_INTERACTION_ID = "67f520edcb6927c7b29ab021"

interface PreviousComparison {
    name: string
    run: ExecutionRun
}

interface LoadPreviousComparisonProps {
    onRunSelected: (run: ExecutionRun) => void
}
export function LoadPreviousComparison({ onRunSelected }: LoadPreviousComparisonProps) {
    const { client, isLoading } = useUserSession()

    const [open, setOpen] = useState(false)
    const [runs, setRuns] = useState<PreviousComparison[]>([])
    const [filterValue, setFilterValue] = useState("")

    const filteredOptions = runs?.filter((run) =>
        run.name.toLowerCase().includes(filterValue.toLowerCase())
    )

    const handleRunSelection = (run: ExecutionRun) => {
        onRunSelected(run)
        setOpen(false)
    }

    useEffect(() => {
        if (!client || isLoading) {
            return
        }

        client.runs.find({ query: { interaction: COMPARE_INTERACTION_ID } }).then((result) => {
            const previousComparisons: PreviousComparison[] = []
            const filteredValue = result.filter(run => !run.error).sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime())
            filteredValue.forEach(run => {
                const tagName = run.tags?.find(tag => tag.startsWith("taskName:"))?.split("taskName: ")[1]
                const name = `${tagName ? tagName : run.id} - ${(new Date(run.updated_at)).toLocaleDateString()}`
                previousComparisons.push({
                    name,
                    run
                })
            })
            setRuns(previousComparisons)
        })
    }, [client, isLoading])

    return (
        <>
            <Button size="sm" onClick={() => setOpen(true)}>
                <ListRestart className="size-4 mr-1" />
                Load Previous
            </Button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Search Previous Comparison</DialogTitle>
                    </DialogHeader>
                    <Input
                        value={filterValue}
                        onChange={(e) => setFilterValue(e.target.value)}
                        placeholder={"Filter previous comparisons..."}
                    />
                    <div className="space-y-4 h-[350px] overflow-y-auto">
                        {
                            filteredOptions.length === 0 ? (
                                <div className="text-center text-muted-foreground">
                                    No previous comparisons found.
                                </div>
                            ) : (
                                filteredOptions.map((run) => (
                                    <Button
                                        key={run.run.id}
                                        variant="outline"
                                        className="w-full justify-start"
                                        onClick={() => handleRunSelection(run.run)}
                                    >
                                        {run.name}
                                    </Button>
                                ))
                            )
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}